import { ModuleRegistry } from "seneca-common/features/module/registry";

import { markAnswer } from "./logic/answers";
import { generateContent } from "./logic/content";
import { canBeTested } from "./logic/tested";

export const MODULE_TYPE = "equation";
export type TYPE = "equation";

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .canBeTested(canBeTested)
    .back.staticInformation()
    .displayName("Equation")
    .root.register();
